import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useHistory} from 'react-router-dom';
import {FileList} from './FileList';
import Empty from '../../../_common/components/Empty';
import ButtonAction from '../../../_common/components/ButtonAction';
import PopupUploadFiles from '../../../_common/components/PopupUploadFiles';
import {useOrderDetailsUIFilesContext} from '../OrderDetailsUIFilesContext';
import {pathnames as P} from '../../../_common/constants/pathnames';
import Spinner from '../../../_common/components/Spinner';

const TabOrderDocuments = () => {
  const history = useHistory();
  const {fileList, uploadFiles, loading} = useOrderDetailsUIFilesContext();

  return loading ? <Spinner customContainerStyles={'d-flex justify-content-center'}/> : (
    <>
      <div className={'d-flex w-100 justify-content-center mb-6'}>
        <PopupUploadFiles onUploadFile={uploadFiles}/>
      </div>
      <div>
        {(fileList.length > 0)
          ? <FileList/>
          : <Empty message={<FormattedMessage id={'no-files'} defaultMessage={'No files'}/>}
                   customContainerClassname={'py-10'}
          />
        }
      </div>
      <ButtonAction
        useIcon={'/media/common/Check-in-circle_white.svg'}
        label={
          <FormattedMessage
            id={'tab-order-documents-button-label-complete'}
            defaultMessage={'Complete'}
          />
        }
        onClick={() => {
          history.push(P.ORDERS_PAGE);
        }}
        customClassnames={'d-block mx-auto'}
        disabled={false}
      />
    </>
  );
};

export default TabOrderDocuments;
